const getDataFromStorage = (key) => {
  try {
    const auth64 = localStorage.getItem(key);
    return JSON.parse(auth64 ? atob(auth64) : '{}');
  } catch (e) {
    return {};
  }
};

export default getDataFromStorage;
